export default __webpack_public_path__ + "assets/img_calculator_holidayhome_cheap-d6c46f2d.jpg";